import { subDays, addDays } from "date-fns";

const ProductDisplayConfigs = {
  master: {
    title: "Product Display",
    apiName: "masterdata/productdisplay",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: { 
      // add_params
      with_parent: 1,
    },
  },
  dialog: {
    title: "Product Display",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Parent",
      field: "parent_id",
      type: "object",
      object_name: "data_parent",
      object_field: "name",
      editor: true,
      table: true,
      filter: true,
    },
    {
      name: "Code",
      field: "code",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
  ],
};

export default ProductDisplayConfigs;
